import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AllocateCardsToMerchant, CardsCountQuery, DashboardInfo, FundingTransaction, MerchantStatus, TopupMerchantAccount, TopupMerchantWallet, Transaction } from './pages/home/models';
import { Observable } from 'rxjs';
import { EnvironmentService } from './services/environment.service';
import { WalletDto } from './components/utils/models/walletDto';
import { TopupMerchantWalletResult } from './components/utils/models/topup-merchant-wallet-result';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient, private environmentService: EnvironmentService) { }

  createFoundInstruction(transaction: FundingTransaction): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(this.environmentService.getConfig('BackendApi') + 'api/FundingInstructions', transaction, { headers });
  }

  getUserWallets(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(this.environmentService.getConfig('BackendApi') + 'api/Wallets/GetByUser', { headers });
  }

  getWalletsByMerchant(merchantId: number): Observable<WalletDto[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<WalletDto[]>(this.environmentService.getConfig('BackendApi') + 'api/Wallets/GetByMerchant?merchantId=' + merchantId, { headers });
  }

  getCardsCountByStatus(cardsCountQuery: CardsCountQuery): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(this.environmentService.getConfig('BackendApi') + 'api/Cards/GetCardsCountByStatus', cardsCountQuery, { headers });
  }

  getCardPricelistByMerchant(merchantId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(this.environmentService.getConfig('BackendApi') + 'api/Cards/GetCardAllocationPriceByMerchant?merchantId=' + merchantId, { headers });
  }

  allocateCardsToMerchant(allocateCardsToMerchant: AllocateCardsToMerchant): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(this.environmentService.getConfig('BackendApi') + 'api/Cards/AllocateCardsToMerchant', allocateCardsToMerchant, { headers });
  }

  getUserAccounts(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(this.environmentService.getConfig('BackendApi') + 'api/MerchantAccounts/GetByMerchant', { headers });
  }

  getUserPricelist(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(this.environmentService.getConfig('BackendApi') + 'api/Pricelists/GetPriceByMerchant', { headers });
  }

  getMerchants(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(this.environmentService.getConfig('BackendApi') + 'api/Merchants', { headers });
  }

  getMerchant(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(this.environmentService.getConfig('BackendApi') + 'api/Merchants/GetMerchant', { headers });
  }

  getMerchantById(id: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(this.environmentService.getConfig('BackendApi') + 'api/Merchants/GetMerchantById?id=' + id, { headers });
  }

  getPricelistByUser(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(this.environmentService.getConfig('BackendApi') + 'api/Pricelists/GetPriceByUser', { headers });
  }

  getPricelistByMerchant(merchantId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(this.environmentService.getConfig('BackendApi') + 'api/Pricelists/GetPriceByMerchant?merchantId=' + merchantId, { headers });
  }

  getDashboardInfo(): Observable<DashboardInfo> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<DashboardInfo>(this.environmentService.getConfig('BackendApi') + 'api/Merchants/DashboardInfo');
  }

  getTransactionsByMerchant(): Observable<Transaction[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<Transaction[]>(this.environmentService.getConfig('BackendApi') + 'api/Transactions/GetByMerchant?orderby=id desc', { headers });
  }

  getTransactionReport(type: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(this.environmentService.getConfig('BackendApi') + 'api/Transactions/GenerateReport?type=' + type);
  }

  getMerchantDocuments(merchantId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<any>(this.environmentService.getConfig('BackendApi') + 'api/MerchantDocuments/GetMerchantDocuments?merchantId=' + merchantId, { headers });
  }

  changeMerchantStatus(merchantStatus: MerchantStatus): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(this.environmentService.getConfig('BackendApi') + 'api/Merchants/ChangeStatus', merchantStatus, { headers });
  }

  topupMerchantAccount(topupMerchantAccount: TopupMerchantAccount): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(this.environmentService.getConfig('BackendApi') + 'api/MerchantAccounts/TopupMerchantAccount', topupMerchantAccount, { headers });
  }

  topupMerchantWallet(topupMerchantWallet: TopupMerchantWallet): Observable<TopupMerchantWalletResult> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<TopupMerchantWalletResult>(this.environmentService.getConfig('BackendApi') + 'api/Wallets/TopupMerchantWallet', topupMerchantWallet, { headers });
  }
}
